<template>
  <v-container grid-list-lg>
    <v-layout column class="ch-auditlog-info-component">
      <v-flex xs6>
        <v-card>
          <v-card-text class="body-form auditlog-info-field-border">
            <v-layout column class="ch-info-field-wrapper ma-0 pb-3">
              <v-flex xs12 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <span class="ml-2">Domain Index</span>
                  </div>
                  <div class="ch-info-field-body">
                    <v-text-field
                      class="pt-0"
                      v-model="domain_index"
                      readonly
                    ></v-text-field>
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <span class="ml-2">Hotel Index</span>
                  </div>
                  <div class="ch-info-field-body">
                    <v-text-field
                      class="pt-0"
                      v-model="hotel_index"
                      readonly
                    ></v-text-field>
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <span class="ml-2">Event Date & Time</span>
                  </div>
                  <div class="ch-info-field-body">
                    <v-text-field
                      class="pt-0"
                      v-model="time"
                      readonly
                    ></v-text-field>
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <span class="ml-2">Hotel</span>
                  </div>
                  <div class="ch-info-field-body">
                    <v-text-field
                      class="pt-0"
                      v-model="hotel_name"
                      readonly
                    ></v-text-field>
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <span class="ml-2">Operator Name</span>
                  </div>
                  <div class="ch-info-field-body">
                    <v-text-field
                      class="pt-0"
                      v-model="actor_name"
                      readonly
                    ></v-text-field>
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <span class="ml-2">Operator Email</span>
                  </div>
                  <div class="ch-info-field-body">
                    <v-text-field
                      class="pt-0"
                      v-model="actor_email"
                      readonly
                    ></v-text-field>
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <span class="ml-2">Event Type</span>
                  </div>
                  <div class="ch-info-field-body">
                    <v-text-field
                      class="pt-0"
                      v-model="action"
                      readonly
                    ></v-text-field>
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <span class="ml-2">Location</span>
                  </div>
                  <div class="ch-info-field-body">
                    <v-text-field
                      class="pt-0"
                      v-model="location"
                      readonly
                    ></v-text-field>
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <span class="ml-2">Application</span>
                  </div>
                  <div class="ch-info-field-body">
                    <v-text-field
                      class="pt-0"
                      v-model="consumer"
                      readonly
                    ></v-text-field>
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <span class="ml-2">Data</span>
                  </div>
                  <div class="ch-info-field-body">
                    <div v-if="before_data">
                      <ul>
                        <li v-for="diff in diffs" :key="diff.type">
                          <span v-if="diff.type === 'update'">
                            <v-chip color="primary" text-color="white" small>Changed</v-chip>
                            {{diff.key}}: {{diff.oldValue}} -> {{diff.value}}
                          </span>
                          <span v-else-if="diff.type === 'add'">
                            <v-chip color="green" text-color="white" small>Added</v-chip>
                            {{diff.key}}: {{diff.value}}
                          </span>
                          <span v-else-if="diff.type === 'remove'">
                            <v-chip color="red" text-color="white" small>Deleted</v-chip>
                            {{diff.key}}: {{diff.value}}
                          </span>
                          <span v-else>
                            <v-chip color="red" text-color="white" small>Unknown</v-chip>
                            {{diff.key}}: {{diff.value}}
                          </span>
                        </li>
                      </ul>
                    </div>
                    <pre v-else>{{ after_data }}</pre>
                  </div>
                </div>
              </v-flex>                                                        
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <div class="btn-wrapper">
              <router-link :to="{name: 'auditLogs'}">
                <button class="ch-menu-btn ch-menu-backbtn" type="button">
                  <i class="fas fa-angle-left fa-fw"></i>
                  LIST
                </button>
              </router-link>
              <v-spacer></v-spacer>
              <button
                class="save"
                @click="openDialog"
              >
                <i class="fas fa-print fa-fw"></i>
                <span>PRINT VIEW</span>
              </button>
            </div>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { auditLogsEventBus } from '@/components/admin/auditLogs/auditLogsEventBus';
  import _ from 'lodash';
  import changeset from 'diff-json';
  import api from '../../../api';

  export default {
    data() {
      return {
        id: null,
        domain_index: null,
        hotel_index: null,
        time: null,
        hotel_name: null,
        actor_name: null,
        actor_email: null,
        action: null,
        target: null,
        location: null,
        consumer: null,
        before_data: null,
        after_data: null,
      };
    },
    methods: {
      getAuditLogDetail() {
        api.getAuditLogDetail(this.id)
        .then((result) => {
          if (result.status === 200) {
            Object.assign(this, result.data);
            this.domain_index = result.data.index.domain_index;
            this.hotel_index = result.data.index.hotel_index ? result.data.index.hotel_index : null;
            this.time = this.$moment(result.data.time).format('YYYY-MM-DD HH:mm:ss');
            this.hotel_name = result.data.hotel ? result.data.hotel.hotel_name : null;
            this.actor_name = result.data.actor.actor_name;
            this.actor_email = result.data.actor.actor_email;
            if (_.isString(result.data.after_data)) {
              this.after_data = JSON.parse(result.data.after_data);
            }
            if (result.data.before_data && _.isString(result.data.before_data)) {
              this.before_data = JSON.parse(result.data.before_data);
              this.diffs = this.createDiff(this.before_data, this.after_data);
            }
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
          // NOTE: 삭제된 아이템
          if (err.response.status === 404) {
            console.error('Invalid page', err.response);
            this.$router.push({ name: 'auditLogs' });
          }
        });
      },
      /**
       * @description 정보창 상단 타이틀 복사
       */
      copyText() {
        const copyTextInfo = document.createElement('input');
        const body = document.getElementsByTagName('body')[0];
        body.appendChild(copyTextInfo);
        copyTextInfo.value = this.domain_name;
        copyTextInfo.select();
        document.execCommand('Copy');
        copyTextInfo.remove();
        this.alert.type = 'check_circle';
        this.alert.color = 'green';
        this.alert.message = 'Copied';
        this.alertOccur();
      },
      openDialog() {
        auditLogsEventBus.$emit('openDialog');
      },
      createDiff(oldone, newone) {
        const res = [];
        const diffs = changeset.diff(oldone, newone);
        diffs.forEach((diff) => {
          if (diff.changes) {
            diff.changes.forEach(diff2 => res.push(diff2));
          } else {
            res.push(diff);
          }
        });
        return res;
      },
    },
    mounted() {
      this.id = this.$route.params.id;
      this.getAuditLogDetail();
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/auditLogs/AuditLogsDetailInfo.vue